import React from 'react';
import LoadHome from 'bundle-loader?lazy&name=home!./routes/home/home.jsx';

export const routes = [
    {
        pattern: '/',
        load: LoadHome,
        requireAuthentication: true,
        title: 'Home - Reward Choice Hatch'
    },
    {
        pattern: '/home',
        load: LoadHome,
        requireAuthentication: true,
        title: 'Home - Reward Choice Hatch'
    }
];

const Bundle = ( Component ) => (
     
    ( props ) => (
        <Component { ...props } />
    )
);

export const getMiddleware = () => {
    return [
        // Load Bundles
        ( action, nextRoute, prevRoute ) => {
            const { match } = nextRoute;

            if (
                match &&
                    !match.render &&
                    typeof match.load === 'function'
            ) {
                match.load( ( asyncModule ) => {
                    match.render = Bundle( asyncModule.default ? asyncModule.default : asyncModule );
                    action.ok();
                } );
            } else {
                action.ok();
            }
        }
    ];
};
